import { cn } from "../../utils/cn";

/**
 * 제품명·버전 — 기능 리스트·인증 신청서의 «세모(SEMO) v1.0» 과 같은 표기(GS 검수 A4-15).
 * 발주기관 웹 푸터·설정, 세 웹의 로그인 화면이 이 한 값을 쓴다. 버전을 올릴 때 여기만 바꾼다.
 */
export const PRODUCT_NAME_VERSION = "세모(SEMO) v1.0";

/**
 * 사업자 정보 — 푸터·로그인 하단·설정 «사업자 정보» 가 같은 표기를 쓰도록 한곳에 둔다(GS 검수 A4-18).
 * 법인 영문 표기는 대표 지시(2026-09-30)대로 «NCihy.inc».
 */
export const COMPANY_INFO = {
  name: "(주)엔씨하이 (NCihy.inc)",
  ceo: "박영각",
  businessNumber: "275-87-03131",
  address: "서울특별시 마포구 월드컵북로 400 서울경제진흥원 2층",
  supportPhone: "070-7666-9219",
  email: "semo.io.kr@gmail.com",
} as const;

/** 저작권 줄 — 로그인·가입 하단 */
export const companyCopyright = (year: number = new Date().getFullYear()) =>
  `© ${year} ${COMPANY_INFO.name}. All rights reserved.`;

/** 제품명·버전 한 줄 */
export function ProductVersionLabel({ className }: { className?: string }) {
  return (
    <p
      className={cn("text-xs text-muted-foreground", className)}
      data-testid="product-version"
    >
      {PRODUCT_NAME_VERSION}
    </p>
  );
}
